import PropTypes from "prop-types";
import LocationIcon from "assets/svg/location_icon_2.svg";
import Button from "components/common/button";
import { LazyImage } from "components/common/lazy-image/LazyImage";
import styles from "./styles.module.css";

const MapView = ({ title, onClick }) => {
  return (
    <div className={styles.mapWrap} onClick={onClick}>
      <div className={styles.mapButton}>
        <LazyImage src="/assets/images/listing-detail-view-map.png" alt={title} className={styles.image} />
        <Button size="M" shadow>
          <h2 className={styles.locationIconWrap}>
            <LocationIcon />
            {title} Adresi
          </h2>
        </Button>
      </div>
    </div>
  );
};

MapView.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default MapView;
